/**
 * Created by istvan.rozsa on 2017. 04. 25..
 */

export default function (form, inputName) {
	if (form && form[inputName]) {
		return (form.$submitted || form[inputName].$touched) && !form[inputName].$valid;
	}
	return true;
};
